module.exports = __webpack_public_path__ + "static/media/oq-logo-white.775a749a.png";